import { Reveal, SectionLabel } from "./Reveal";
import { MACHINERY } from "@/lib/data";
import { useI18n } from "@/context/LanguageContext";

const BG =
  "https://images.unsplash.com/photo-1738162837451-2041c1418f54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxjbmMlMjBsYXNlciUyMGN1dHRpbmd8ZW58MHx8fHwxNzg2OTU0MTcwfDA&ixlib=rb-4.1.0&q=85&w=1600";

export const Machinery = () => {
  const { t } = useI18n();
  return (
    <section id="capabilities" className="relative bg-ink text-white py-16 sm:py-20 lg:py-32 overflow-hidden noise">
      <div className="absolute inset-0 grid-lines opacity-40" />
      <img src={BG} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-15 hidden lg:block" />
      <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-transparent to-ink hidden lg:block" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionLabel index="/ 02">{t.labels.capabilities}</SectionLabel>
          <h2 className="font-display font-700 uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mb-4">
            {t.machinery.heading[0]} <span className="text-safety">{t.machinery.heading[1]}</span>
          </h2>
          <p className="text-white/50 max-w-xl mb-16 font-mono2 text-sm tracking-wide">
            {t.machinery.sub}
          </p>
        </Reveal>

        {/* Technical grid — every cell bordered */}
        <div className="grid md:grid-cols-2 border-t border-l border-white/15">
          {MACHINERY.map((m, i) => (
            <Reveal key={m.code} delay={i * 0.1}>
              <div
                data-testid={`machinery-cell-${i}`}
                className="group relative border-r border-b border-white/15 p-8 lg:p-10 hover:bg-white/[0.03] transition-colors h-full"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-mono2 text-xs tracking-widest text-white/40">{m.code}</span>
                  <div className="font-display font-700 text-5xl lg:text-6xl text-safety leading-none">
                    {m.spec}
                  </div>
                </div>
                <h3 className="font-display font-500 uppercase text-2xl lg:text-3xl mb-3 group-hover:text-safety transition-colors">
                  {t.machinery.items[i].name}
                </h3>
                <p className="text-white/50 text-sm max-w-sm leading-relaxed">{t.machinery.items[i].detail}</p>
                <div className="absolute bottom-0 left-0 h-1 bg-safety w-0 group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
